import React from 'react';
import Main from "./pages/main/main";
import Faq from './pages/faq/faq';
import Footer from "./components/footer/footer";
import {
  Switch,
  Route,
  Redirect,
  BrowserRouter as Router,
} from "react-router-dom";
import LoadingLazy from "./components/suspense";
import { QueryClient, QueryClientProvider } from 'react-query';

import Header from './components/header/header';

const queryClient = new QueryClient()

const isRedirectTo = () => {
  const isReadFaq = localStorage.getItem('isFaqRead');
  return isReadFaq ? '/main' : '/info/faq';
}

function App() {
  return (
      <div className="App">
        <Router>
          <LoadingLazy>
            <Header />
          </LoadingLazy>
          <QueryClientProvider client={queryClient}>
          <Switch>
            <Route path="/tournament/:id" exact children={<Main />} />
            <Route path="/:region" exact children={<Main />} />
            <Route path="/info/faq" exact children={<Faq />} />
            <Redirect to={isRedirectTo()} />
          </Switch>
          </QueryClientProvider>
          <Footer/>
        </Router>
      </div>
  );
}

export default App;
